import React from 'react';
import * as PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import IconAsset from 'Components/layouts/kiosk/KioskLayout/LayoutComponents/IconAsset';
import {Desktop, Mobile} from 'Utils/ResponsiveUtil';
import {DESKTOP_QUICK_LINKS_SIZE} from 'Utils/explorer/explorerConstants';
import QuickLink from './QuickLink';

function MoreLessButton(props) {
    return (
        <div className="item" key="more-less">
            <div className="quick-links-item-dummy" title="more" onClick={props.onClick}>
                <div
                    className="quick-links-item-circle"
                    style={{
                        backgroundColor: '#858585',
                    }}
                >
                    <IconAsset
                        icon={{
                            src: '/images/icon-more.svg',
                            backgroundColor: 'black',
                            size: props.size,
                        }}
                        title="more"
                    />
                </div>
                <div className="quick-links-icon-copy">{props.showMore ? 'less' : 'more'}</div>
            </div>
        </div>
    );
}

MoreLessButton.propTypes = {
    onClick: PropTypes.func,
    size: PropTypes.string,
    showMore: PropTypes.bool,
};

const QuickLinks = ({quickLinks, searchFilters, selectQuickLink}) => {
    let buttons = searchFilters;
    let size = '46px';
    if (!searchFilters.length) {
        buttons = quickLinks;
        size = '28px';
    }

    const [showMore, setShowMore] = React.useState(false);

    if (!buttons.length) return null;

    const onChange = () => {
        setShowMore(!showMore);
    };

    return (
        <>
            <Mobile>
                <div id="quick-links" data-testid="quick-links" className={showMore ? 'open' : ''}>
                    <div className="quick-links-container">
                        <Grid
                            container
                            spacing={1}
                            justifyContent="space-around"
                            style={{marginTop: 0}}
                        >
                            {buttons.map((quickLink, index) => {
                                if (
                                    index < 3 ||
                                    (showMore && index < 4) ||
                                    (index < 4 && buttons.length === 4)
                                ) {
                                    return (
                                        <QuickLink
                                            key={quickLink.uuid}
                                            quickLink={quickLink}
                                            onClick={() => selectQuickLink(quickLink)}
                                            searchFilters={searchFilters}
                                            size={size}
                                        />
                                    );
                                }
                                return '';
                            })}
                            {buttons.length > 4 &&
                                !showMore && (
                                    <MoreLessButton
                                        showMore={showMore}
                                        onClick={onChange}
                                        size={size}
                                    />
                                )}
                        </Grid>

                        {showMore && (
                            <Grid
                                container
                                spacing={1}
                                justifyContent="space-around"
                                style={{marginTop: 8}}
                            >
                                {buttons.map((quickLink, index) => {
                                    // explorer mobile shows max of 7 QL
                                    if (index >= 4 && index < 7) {
                                        return (
                                            <QuickLink
                                                key={quickLink.uuid}
                                                quickLink={quickLink}
                                                onClick={() => selectQuickLink(quickLink)}
                                                searchFilters={searchFilters}
                                                size={size}
                                            />
                                        );
                                    }
                                    return '';
                                })}
                                {buttons.length < 8 &&
                                    [...new Array(7 - buttons.length)].map(space => (
                                        <div className="item" key={space}>
                                            <div className="quick-links-item" />
                                        </div>
                                    ))}
                                <MoreLessButton
                                    showMore={showMore}
                                    onClick={onChange}
                                    size={size}
                                />
                            </Grid>
                        )}
                    </div>
                </div>
            </Mobile>
            <Desktop>
                <div id="quick-links" data-testid="quick-links">
                    {buttons.map(quickLink => (
                        <QuickLink
                            key={quickLink.uuid}
                            quickLink={quickLink}
                            onClick={() => selectQuickLink(quickLink)}
                            searchFilters={searchFilters}
                            size={DESKTOP_QUICK_LINKS_SIZE}
                        />
                    ))}
                </div>
            </Desktop>
        </>
    );
};

QuickLinks.propTypes = {
    searchFilters: PropTypes.array,
    quickLinks: PropTypes.array,
    selectQuickLink: PropTypes.func,
};

export default QuickLinks;
